var _circle, _circle2, _circle3, _circle4, _ellipse, _path, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoSandboxedMetric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 205,
    viewBox: "0 0 205 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5499,
    cy: 41.5157,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.476,
    cy: 59.1768,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.956,
    cy: 68.2463,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.569,
    cy: 98.3181,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.8071,
    cy: 100.347,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.065 100.347C167.065 137.155 136.961 167.009 99.8071 167.009C62.6531 167.009 32.5488 137.155 32.5488 100.347C32.5488 63.539 62.6531 33.6853 99.8071 33.6853C136.961 33.6853 167.065 63.539 167.065 100.347Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.1144,
    cy: 69.6783,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.6671,
    cy: 181.851,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.171,
    cy: 192.83,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.45,
    cy: 179.942,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 123.197,
    cy: 177.078,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 127.971,
    cy: 190.92,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 109.353,
    cy: 196.648,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 173.793,
    cy: 166.815,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 189.068,
    cy: 138.414,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 179.76,
    cy: 123.616,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 183.58,
    cy: 93.5447,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 191.455,
    cy: 77.3156,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 185.967,
    cy: 40.7997,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 73.3164,
    cy: 199.035,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 39.1855,
    cy: 194.262,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 43.959,
    cy: 185.908,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 12.9336,
    cy: 147.722,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 19.8554,
    cy: 132.925,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2.19333,
    cy: 94.4994,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 21.0488,
    cy: 64.6664,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 24.8672,
    cy: 22.4226,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 61.3828,
    cy: 6.19333,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 107.922,
    cy: 24.8093,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.937,
    cy: 18.8425,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169.976 150.347C168.921 150.347 168.066 149.493 168.066 148.438C168.066 147.384 168.921 146.529 169.976 146.529",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01172 117.65C7.06621 117.65 7.92104 116.795 7.92104 115.741C7.92104 114.686 7.06621 113.831 6.01172 113.831",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0312 22.4227C75.0857 22.4227 75.9406 21.5679 75.9406 20.5134C75.9406 19.4589 75.0857 18.6041 74.0312 18.6041",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.332 15.7399C119.278 15.7399 118.423 16.5947 118.423 17.6492C118.423 18.7037 119.278 19.5585 120.332 19.5585",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83008 166.934H15.7967M25.8207 155.836V157.388M37.5153 166.934H39.0666M25.8207 176.481V178.271M25.8207 180.658V186.982M21.4053 166.934C24.3887 166.934 25.94 162.638 25.94 162.638C25.94 162.638 26.4173 166.934 30.236 166.934C28.5176 166.934 26.0593 168.486 25.8207 171.588C25.8207 171.588 25.5428 169.048 24.6273 168.128C23.863 167.359 21.4053 166.934 21.4053 166.934Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.209 30.0597L172.242 30.0597M162.099 45.8116L162.218 39.6063M150.524 30.0597L148.972 30.0597M162.099 20.7518L162.099 8.57985M166.634 30.0597C163.65 30.0597 162.099 34.3557 162.099 34.3557C162.099 34.3557 161.622 30.0597 157.803 30.0597C159.521 30.0597 161.98 28.5084 162.218 25.4057C162.218 25.4057 162.496 27.9459 163.412 28.8664C164.176 29.635 166.634 30.0597 166.634 30.0597Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.483 56.4899L68.9824 56.01C63.7826 56.4118 61.8173 60.5124 61.4846 62.5125L61.0024 116.013L61.0102 139.513L63.5112 142.512L66.512 145.011L86.512 145.004L86.5117 144.004L89.0117 144.003L93.5117 144.002L129.512 143.99L132.511 142.489L134.51 140.488L136.01 138.988L136.501 112.988L136.485 64.9876C136.483 58.5876 131.816 56.6558 129.483 56.4899Z",
    fill: "white",
    stroke: "#787E8C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6013 144.76L128.727 144.079C133.11 144.028 136.636 140.46 136.635 136.077L136.611 64.3992C136.609 59.981 133.026 56.4004 128.608 56.4019L69.4824 56.4215C65.0641 56.423 61.4836 60.0059 61.4851 64.4242L61.5091 136.763C61.5106 141.217 65.1483 144.812 69.6013 144.76Z",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2857 91.2222H81.7143C80.9568 91.2213 80.2306 90.9167 79.6949 90.3751C79.1593 89.8335 78.858 89.0992 78.8571 88.3333C78.8571 87.9502 78.7066 87.5828 78.4387 87.312C78.1708 87.0411 77.8075 86.8889 77.4286 86.8889C77.0497 86.8889 76.6863 87.0411 76.4184 87.312C76.1505 87.5828 76 87.9502 76 88.3333C76.0016 89.8652 76.6042 91.3338 77.6755 92.417C78.7467 93.5002 80.1993 94.1095 81.7143 94.1111V95.5556C81.7143 95.9386 81.8648 96.306 82.1327 96.5769C82.4006 96.8478 82.764 97 83.1429 97C83.5217 97 83.8851 96.8478 84.153 96.5769C84.4209 96.306 84.5714 95.9386 84.5714 95.5556V94.1111H87.4286V95.5556C87.4286 95.9386 87.5791 96.306 87.847 96.5769C88.1149 96.8478 88.4783 97 88.8571 97C89.236 97 89.5994 96.8478 89.8673 96.5769C90.1352 96.306 90.2857 95.9386 90.2857 95.5556V94.1111C91.8012 94.1111 93.2547 93.5024 94.3263 92.4188C95.398 91.3353 96 89.8657 96 88.3333C96 86.801 95.398 85.3314 94.3263 84.2478C93.2547 83.1643 91.8012 82.5556 90.2857 82.5556H81.7143C80.9565 82.5556 80.2298 82.2512 79.694 81.7094C79.1582 81.1676 78.8571 80.4328 78.8571 79.6667C78.8571 78.9005 79.1582 78.1657 79.694 77.6239C80.2298 77.0821 80.9565 76.7778 81.7143 76.7778H90.2857C91.0432 76.7787 91.7694 77.0833 92.3051 77.6249C92.8407 78.1665 93.142 78.9008 93.1429 79.6667C93.1429 80.0498 93.2934 80.4172 93.5613 80.688C93.8292 80.9589 94.1925 81.1111 94.5714 81.1111C94.9503 81.1111 95.3137 80.9589 95.5816 80.688C95.8495 80.4172 96 80.0498 96 79.6667C95.9984 78.1348 95.3958 76.6662 94.3245 75.583C93.2533 74.4998 91.8007 73.8905 90.2857 73.8889V72.4444C90.2857 72.0614 90.1352 71.694 89.8673 71.4231C89.5994 71.1522 89.236 71 88.8571 71C88.4783 71 88.1149 71.1522 87.847 71.4231C87.5791 71.694 87.4286 72.0614 87.4286 72.4444V73.8889H84.5714V72.4444C84.5714 72.0614 84.4209 71.694 84.153 71.4231C83.8851 71.1522 83.5217 71 83.1429 71C82.764 71 82.4006 71.1522 82.1327 71.4231C81.8648 71.694 81.7143 72.0614 81.7143 72.4444V73.8889C80.1988 73.8889 78.7453 74.4976 77.6737 75.5812C76.602 76.6647 76 78.1343 76 79.6667C76 81.199 76.602 82.6686 77.6737 83.7522C78.7453 84.8357 80.1988 85.4444 81.7143 85.4444H90.2857C91.0435 85.4444 91.7702 85.7488 92.306 86.2906C92.8418 86.8324 93.1429 87.5672 93.1429 88.3333C93.1429 89.0995 92.8418 89.8343 92.306 90.3761C91.7702 90.9179 91.0435 91.2222 90.2857 91.2222Z",
    fill: "#787E8C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1262 110.817C92.9721 110.665 92.8501 110.484 92.7674 110.285C92.6844 110.084 92.6427 109.869 92.6447 109.653M93.1262 110.817L95.3018 110.668C95.4396 110.538 95.5494 110.381 95.6242 110.206C95.699 110.032 95.7374 109.844 95.7368 109.654H95.9868C95.9868 109.654 95.9868 109.653 95.9868 109.653C95.9867 109.21 95.8107 108.785 95.4975 108.471C95.1842 108.157 94.7591 107.981 94.3158 107.981C93.8725 107.981 93.4474 108.157 93.1341 108.471C92.821 108.784 92.6451 109.209 92.6447 109.653M93.1262 110.817C93.278 110.973 93.4588 111.097 93.6585 111.183C93.8592 111.27 94.0749 111.316 94.2934 111.319C94.5119 111.322 94.7288 111.282 94.9318 111.201C95.1342 111.12 95.3187 111.001 95.475 110.849L93.1262 110.817ZM92.6447 109.653C92.6447 109.653 92.6447 109.653 92.6447 109.654H92.8947L92.6448 109.651C92.6447 109.652 92.6447 109.652 92.6447 109.653ZM102.842 119.865C102.399 119.865 101.974 119.688 101.661 119.375C101.348 119.061 101.172 118.636 101.171 118.193C101.171 118.193 101.171 118.193 101.171 118.193L101.421 118.192L102.842 119.865ZM102.842 119.865H102.842M102.842 119.865H102.842M102.842 119.865C103.285 119.865 103.71 119.688 104.023 119.375C104.336 119.061 104.512 118.637 104.513 118.194M102.842 119.865L101.681 116.999C101.832 116.846 102.013 116.725 102.212 116.642C102.412 116.559 102.626 116.517 102.843 116.519C103.066 116.519 103.287 116.564 103.492 116.653C103.696 116.741 103.88 116.869 104.033 117.031C104.186 117.182 104.308 117.362 104.391 117.561C104.474 117.762 104.515 117.977 104.513 118.194M104.513 118.194C104.513 118.194 104.513 118.194 104.513 118.195L104.263 118.192L104.513 118.193C104.513 118.193 104.513 118.193 104.513 118.194ZM126.75 101.115V101.115C126.75 101.27 126.72 101.422 126.661 101.565C126.602 101.707 126.516 101.836 126.407 101.945C126.298 102.054 126.169 102.14 126.027 102.199C125.885 102.258 125.733 102.289 125.579 102.288H125.579C125.425 102.289 125.273 102.258 125.131 102.199C124.989 102.14 124.86 102.054 124.751 101.945C124.642 101.836 124.556 101.707 124.497 101.565C124.438 101.422 124.408 101.27 124.408 101.115V101.115V98.8585V98.2543L123.981 98.6818L106.503 116.184L106.378 116.31L106.455 116.47C106.718 117.014 106.855 117.612 106.855 118.217C106.856 118.822 106.72 119.42 106.457 119.965C106.195 120.51 105.813 120.989 105.34 121.365C104.867 121.742 104.315 122.007 103.726 122.14C103.136 122.273 102.525 122.271 101.936 122.135C101.347 121.998 100.797 121.73 100.326 121.351C99.8557 120.971 99.4765 120.491 99.2172 119.944C98.9579 119.397 98.8252 118.799 98.8289 118.194L98.8289 118.193C98.8316 117.597 98.9687 117.008 99.2301 116.472L99.3081 116.312L99.1822 116.186L96.3217 113.321L96.1952 113.194L96.0344 113.274C95.4999 113.537 94.9122 113.673 94.3166 113.673C93.721 113.673 93.1335 113.535 92.5992 113.272L92.4384 113.192L92.3117 113.319L83.3879 122.256L83.2501 122.394L83.3505 122.561C83.8484 123.391 84.1137 124.34 84.1184 125.308C84.1183 126.385 83.7996 127.437 83.2025 128.331C82.6053 129.226 81.7566 129.924 80.7637 130.336C79.7707 130.748 78.6782 130.855 77.6241 130.645C76.5701 130.435 75.6018 129.917 74.8418 129.156C74.0818 128.395 73.5641 127.425 73.3544 126.369C73.1447 125.314 73.2524 124.219 73.6637 123.225C74.0751 122.23 74.7716 121.38 75.6653 120.782C76.5587 120.185 77.6091 119.866 78.6835 119.865C79.6503 119.87 80.5979 120.135 81.4266 120.634L81.5942 120.735L81.7324 120.597L90.6544 111.662L90.7798 111.536L90.7027 111.377C90.4396 110.832 90.3029 110.234 90.3025 109.629C90.3022 109.024 90.4384 108.427 90.7008 107.881C90.9632 107.336 91.3452 106.858 91.8181 106.481C92.2911 106.104 92.8428 105.84 93.4322 105.706C94.0215 105.573 94.6333 105.575 95.2219 105.712C95.8104 105.848 96.3606 106.116 96.8314 106.495C97.3022 106.875 97.6814 107.356 97.9407 107.902C98.2 108.449 98.3327 109.047 98.329 109.652L98.3289 109.653C98.3263 110.25 98.1892 110.838 97.9279 111.374L97.8499 111.534L97.9757 111.66L100.852 114.541L100.973 114.662L101.13 114.593C101.669 114.356 102.252 114.234 102.84 114.234C103.429 114.235 104.011 114.358 104.55 114.597L104.707 114.666L104.828 114.545L122.325 97.0228L122.751 96.5962H122.148H119.895C119.584 96.5962 119.286 96.4726 119.067 96.2527C118.847 96.0327 118.724 95.7343 118.724 95.4231C118.724 95.1118 118.847 94.8134 119.067 94.5935C119.286 94.3735 119.584 94.25 119.895 94.25H125.579L125.579 94.25C125.733 94.25 125.885 94.2803 126.027 94.3392C126.169 94.3981 126.298 94.4844 126.407 94.5934C126.516 94.7023 126.602 94.8316 126.661 94.974C126.72 95.1163 126.75 95.2689 126.75 95.423V95.4231V101.115ZM81.7763 125.308V125.307C81.7758 124.696 81.5943 124.098 81.2547 123.59C80.915 123.081 80.4324 122.685 79.8679 122.451C79.3033 122.217 78.6822 122.156 78.083 122.276C77.4838 122.395 76.9334 122.69 76.5015 123.122C76.0695 123.555 75.7754 124.106 75.6561 124.706C75.5368 125.306 75.5978 125.927 75.8313 126.493C76.0648 127.058 76.4604 127.541 76.9682 127.881C77.4759 128.222 78.073 128.403 78.684 128.404H78.6845C79.5043 128.403 80.2902 128.076 80.8698 127.496C81.4494 126.916 81.7754 126.129 81.7763 125.308Z",
    fill: "#787E8C",
    stroke: "white",
    strokeWidth: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 27,
    height: 27,
    rx: 13.5,
    transform: "matrix(-1 0 0 1 141 122)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 27,
    height: 27,
    rx: 13.5,
    transform: "matrix(-1 0 0 1 141 122)",
    stroke: "#194590",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34832_2701)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_34832_2701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.09 130.172C128.09 129.882 128.327 129.645 128.617 129.645C128.907 129.645 129.145 129.882 129.145 130.172V135.973H134.945C135.235 135.973 135.473 136.21 135.473 136.5C135.473 136.79 135.235 137.027 134.945 137.027H129.145V142.828C129.145 143.118 128.907 143.355 128.617 143.355C128.327 143.355 128.09 143.118 128.09 142.828V137.027H122.289C121.999 137.027 121.762 136.79 121.762 136.5C121.762 136.21 121.999 135.973 122.289 135.973H128.09V130.172Z",
    fill: "#194590"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34832_2701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(121 129)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_34832_2701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.7656,
    height: 16.875,
    fill: "white",
    transform: "matrix(-1 0 0 1 136 128.062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSandboxedMetric);
export default __webpack_public_path__ + "static/media/no-sandboxed-metric.556d2d4b621b0cb542b2a08d1aec1b98.svg";
export { ForwardRef as ReactComponent };